import React from 'react';

import { Svg, Path, SvgProps } from 'react-native-svg';

import { colors } from '@/constants/colors';

const GlidersIcon: React.FC<SvgProps> = (props) => {
  const {
    width = '100%',
    height = '100%',
    color = colors.white.primary,
    ...restProps
  } = props;

  return (
    <Svg
      enable-background={'new 0 0 827.25 371.97'}
      viewBox={'0 0 827.25 371.97'}
      width={width}
      height={height}
      {...restProps}
    >
      <Path
        fill={color}
        d={
          'M258.52,266.77C123.94,281.45,8.39,234.23,.43,161.3S95.13,17.35,229.71,2.67c134.58-14.68,250.13,32.54,258.09,105.47,7.95,72.93-94.7,143.95-229.28,158.63ZM562.27,70.23c-24.98-.38-44.76-.28-67.75,2.98,10.11,12.59,12.29,28.04,13.62,43.2,5.64,64.39-73.88,136.65-193.22,157.88,37.36,57.51,128.49,95.89,242.75,97.63,147.61,2.25,268.3-63.45,269.58-146.76,1.27-83.31-117.36-152.67-264.97-154.92Z'
        }
      />
    </Svg>
  );
};

export default GlidersIcon;
